export default "/packs/images/default_profile~2284b17d210612912f85f3ea67729d70.png";